import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputPostalCode: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="Zip Code:">
    {form.getFieldDecorator('postalCode', {
      initialValue,
      rules: [{ message: 'Please enter the location zip code.', required: true }],
    })(<Input allowClear placeholder="Zip Code" />)}
  </Form.Item>
);
